import { useAuth } from "m2m-components/storage/useM2mAuth"
import React, { ReactNode, useMemo } from "react"
import { useCompanyApprovalRequestsCount } from "@/hooks/useCompanyApprovalRequests"

interface CompanyApprovalRequestsCountContextValueType {
    count: number
    refetchCount: () => Promise<void>
}

const CompanyApprovalRequestsCountContext = React.createContext<
    CompanyApprovalRequestsCountContextValueType | undefined
>(undefined)

export const CompanyApprovalRequestsCountProvider = ({
    children
}: {
    children: ReactNode
}) => {
    const { token } = useAuth()
    const { data: countData, refetch } = useCompanyApprovalRequestsCount(token)

    const value: CompanyApprovalRequestsCountContextValueType = useMemo(() => {
        return {
            count: countData?.count ?? 0,
            refetchCount: async () => {
                await refetch()
            }
        }
    }, [countData, refetch])

    return (
        <CompanyApprovalRequestsCountContext.Provider value={value}>
            {children}
        </CompanyApprovalRequestsCountContext.Provider>
    )
}

export const useCompanyApprovalRequestsCountContext = () => {
    const ctx = React.useContext(CompanyApprovalRequestsCountContext)
    if (!ctx) {
        throw new Error("CompanyApprovalRequestsCountContext not found")
    }
    return ctx
}
